import { Mutation, Action, Getter, HasGetter, extractVuexModule, VuexClass } from 'vuex-class-module';
import { Favourite } from '../../model/favourite';

@VuexClass({
  modules: {}
})
class AppState {
  @HasGetter 
  menuItemId: string = '';
  
  @HasGetter
  menuItemText: string = '';

  @HasGetter
  helpUrl: string = '';

  @HasGetter
  favourites: Favourite[] = [];

  @Mutation
  setCurrentMenuItem(state, menuItem) {
    state.menuItemId = menuItem.menuItemId;
    state.menuItemText = menuItem.menuItemText;
    state.helpUrl = menuItem.helpUrl;
  }

  @Mutation
  setFavourites(state, favourites) {
    state.favourites = favourites;
  }
}

const appStateModule = extractVuexModule(AppState);

export default appStateModule;



// WEBPACK FOOTER //
// src/store/modules/app-state.ts